<ng-container [ngSwitch]="mainService.getShopPortalLayoutKind()">
  <app-outstanding-items-webshop *ngSwitchDefault></app-outstanding-items-webshop>
</ng-container>
